export default {
    styleOverrides: {
        root: {
            zIndex: 9999
        }
    }
}
